export default "__VITE_ASSET__C6P3ATHw__"